/** Actionable, content-free explanations for failures before a document reaches a model. */
export function documentProcessingFailureMessage(code: string | null | undefined): string | null {
  if (code === "PRIVACY_OCR_UNAVAILABLE")
    return "The private document reader is unavailable. Ask your clinic administrator to restore it, then retry.";
  if (code === "PRIVACY_OCR_UNREADABLE")
    return "The document could not be read safely. Upload a clearer copy or review the original manually.";
  return null;
}
